import { Component, ViewEncapsulation } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material';
import { version } from '../../../../package.json';

@Component({
    selector: 'app-bottom-sheet',
    templateUrl: './bottom-sheet.page.html',
    styleUrls: ['./bottom-sheet.page.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'app-bottom-sheet'
    }
})

export class BottomSheetComponent {

    appVersion = version;

    constructor(private _bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>) {
    }

    openLink(event: MouseEvent): void {
        this._bottomSheetRef.dismiss();
        event.preventDefault();
    }

}
